export default __webpack_public_path__ + "static/media/Youth_Illustrations-AG Design.d81e6c3e.png";